export var LOAD_STARTUP_DATA = 'LOAD_STARTUP_DATA';
export var STARTUP_DATA_LOADED = 'STARTUP_DATA_LOADED';
export var loadStartupData = function loadStartupData() {
  return {
    type: LOAD_STARTUP_DATA
  };
};
export var startupDataLoaded = function startupDataLoaded() {
  return {
    type: STARTUP_DATA_LOADED
  };
};